import { onMounted, onUnmounted } from 'vue';

// Keys typed into a field belong to that field, so page-level shortcuts should leave them alone.
export const isTextEntryTarget = (target) => {
	return ['INPUT', 'TEXTAREA', 'SELECT'].includes(target?.tagName) || Boolean(target?.isContentEditable);
};

export function useKeyboardShortcut(key, callback) {
	const handler = (e) => {
		if (isTextEntryTarget(e.target)) { return; }
		if (e.key === key) { callback(); }
	};

	onMounted(() => document.addEventListener('keydown', handler));
	onUnmounted(() => document.removeEventListener('keydown', handler));
}
